import DataModel from '../../common/model/DataModel';

export default class CarbonFreeSummaryDataModel extends DataModel {
  constructor(preferenceGroupName) {
    super();

    this.preferenceGroupName = preferenceGroupName;

    this.counterparty = null;
    this.contracts = [];
    this.totalCFAllocation = null;
    this.totalCFDelivered = null;
    this.totalCFRemaining = null;
  }
}